import React from 'react'
import OnVisible from 'react-on-visible'
import MarketoForm from '../../components/MarketoForm'

import './styles.scss'

const TwoColMarketo = ({ data }) => {
  const {
    primary: { title, content, marketo_form_id: mktoId, form_footnote: footnote }
  } = data

  const titleHtml = title?.html
  const contentHtml = content?.html
  const footnoteHtml = footnote?.html

  return (
    <OnVisible className="two-col-marketo">
      <div className="header-bg is-clipped bg-gradient-reverse section">
        <canvas
          style={{
            width: '100vw',
            height: '676px'
          }}
        />
      </div>
      <div className="two-col-marketo-wrapper container">
        <div className="two-col-marketo-columns">
          <div className="two-col-marketo-column two-col-marketo-column-left">
            {titleHtml && <div className="text-icon-columns-content" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
            {contentHtml && (
              <div className="text-icon-columns-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
            )}
          </div>
          <div className="two-col-marketo-column two-col-marketo-column-right two-col-marketo-column-form">
            <div className="two-col-marketo-column-form-wrapper">
              <MarketoForm formId={mktoId} />
              {footnoteHtml && (
                <div className="two-col-marketo-column-form-footnote" dangerouslySetInnerHTML={{ __html: footnoteHtml }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </OnVisible>
  )
}

export default TwoColMarketo
